import { isEmpty } from 'lodash';

const populateFormFields = ({ setValue, selectedAccount }) => {
  const { rawData } = selectedAccount;

  const { ecommerce, brands, accountType, parentAccount, name, storeName } = rawData;

  if (!isEmpty(ecommerce)) setValue('platform', { label: ecommerce?.name, value: ecommerce?.name, id: ecommerce?.id });
  if (!isEmpty(name)) setValue('accountId', name);
  if (!isEmpty(storeName)) setValue('storeName', storeName);
  if (!isEmpty(accountType)) setValue('accountType', { label: accountType?.name, value: accountType?.name, id: accountType?.id });
  if (!isEmpty(parentAccount)) setValue('parentAccount', { label: parentAccount?.name, value: parentAccount?.name, id: parentAccount?.id });
  if (!isEmpty(brands))
    setValue(
      'brand',
      { label: brands[0]?.name, value: brands[0]?.name, id: brands[0]?.id },
    );
};

export default populateFormFields;
